import { render, staticRenderFns } from "./WorkBookSelectTop.vue?vue&type=template&id=81a2ab4c&scoped=true&"
import script from "./WorkBookSelectTop.vue?vue&type=script&lang=js&"
export * from "./WorkBookSelectTop.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookSelectTop.vue?vue&type=style&index=0&id=81a2ab4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a2ab4c",
  null
  
)

export default component.exports